import React from "react";
var __jsx = React.createElement;
import Review from "./components/Review/Review";
import { useTranslation } from "@i18n";
import stl from "./ReviewsPage.module.css";
var ReviewsPage = function ReviewsPage(_ref) {
  var feedbackList = _ref.feedbackList;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: stl.ratingPageContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.allUserratingContainer
  }, /*#__PURE__*/React.createElement("h1", null, t("customer_feedback", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("div", {
    id: "feedback_item_view",
    className: "w-100"
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.MURallContent
  }, feedbackList.map(function (item, i) {
    return /*#__PURE__*/React.createElement(Review, {
      key: i,
      name: item.name,
      date: item.date,
      city: item.city,
      review: item.comment,
      rate: item.rate,
      carName: item.car_title,
      carYear: item.car_year,
      carCondition: item.car_condition
    });
  })))));
};
export default ReviewsPage;